import { z } from "zod/v4";

import { AiSelectorSearchTypeList } from "../../../schemas/ai/ai-old";

export const AiGetSelectorsChatCompletionResponseSchema = z.object({
  selectors: z.string().array(),
});
export type AiGetSelectorsChatCompletionResponseType = z.infer<
  typeof AiGetSelectorsChatCompletionResponseSchema
>;

export const AiGetSelectorsResponseBodySchema =
  AiGetSelectorsChatCompletionResponseSchema.extend({
    sessionId: z.string(),
  });

export type AiGetSelectorsResponseBodyType = z.infer<
  typeof AiGetSelectorsResponseBodySchema
>;

export const AiGetSelectorsRequestBodySchema = z.object({
  html: z.string(),
  custom: z.string().nullish(),
  find: z.enum(AiSelectorSearchTypeList).nullish(),
});

export type AiGetSelectorsRequestBodyType = z.infer<
  typeof AiGetSelectorsRequestBodySchema
>;
